export default "__VITE_ASSET__8Mhb3xAz__"